(function () {
  let flickityInstance;

  function initFlickity() {
    const slider = document.querySelector('.product__image-slider');
    if (!slider || typeof Flickity === 'undefined') return;
    flickityInstance = new Flickity(slider, {
      contain: true,
      wrapAround: true,
      pageDots: false
    });
  }

  function updateMedia(variant) {
    if (!variant || !variant.featured_media) return;

    const currentMediaId = variant.featured_media.id;

    const slider = document.querySelector('.product__image-slider');
    if (slider && flickityInstance) {
      // OPTIMIZATION: Find the specific target image directly instead of looping/mapping all images
      const targetImg = slider.querySelector(`img[data-media-id="${currentMediaId}"]`);
      
      if (targetImg) {
        // Get the index by finding the image's parent cell relative to the slider's cells
        const cell = targetImg.closest('.carousel-cell'); // Adjust this class if Flickity uses a different wrapper
        const cells = Array.from(slider.querySelectorAll('.carousel-cell')); 
        const targetIndex = cells.indexOf(cell);
        
        if (targetIndex >= 0) flickityInstance.select(targetIndex);
      }
      return;
    }

    const mediaList = document.querySelector('.product__media-list');
    if (mediaList) {
      mediaList.querySelectorAll('[data-media-id]').forEach((el) => {
        // OPTIMIZATION: Strict equality is slightly faster than string.includes() if IDs are exact
        el.style.display = parseInt(el.dataset.mediaId) === currentMediaId ? 'block' : 'none';
      });
    }
  }

  function initZoomHover() {
    const containers = document.querySelectorAll('.img_producto_container');
    if (!containers.length) return;

    containers.forEach((container) => {
      const img = container.querySelector('.img_producto');
      if (!img) return;

      const scale = parseFloat(container.dataset.scale) || 1.5;
      let isZooming = false; // Flag to prevent stacking animation frames

      container.addEventListener('mouseover', () => {
        img.style.transform = `scale(${scale})`;
      });

      container.addEventListener('mouseout', () => {
        img.style.transform = 'scale(1)';
      });

      container.addEventListener('mousemove', (e) => {
        // OPTIMIZATION: Throttle rapid mouse movements using the browser's render cycle
        if (isZooming) return;
        isZooming = true;

        window.requestAnimationFrame(() => {
          // OPTIMIZATION: getBoundingClientRect is safer for scrolling layouts than offsetLeft
          const rect = container.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 50; 
          const y = ((e.clientY - rect.top) / rect.height) * 50;
          
          img.style.transformOrigin = `${x}% ${y}%`;
          isZooming = false;
        });
      });
    });
  }

  function initZoomIconTrigger() {
    const zoomIcon = document.querySelector('#product-top .single-nav-img svg.customimagezoom');
    if (!zoomIcon) return;

    zoomIcon.addEventListener('click', (e) => {
      e.preventDefault();
      const activeLink = zoomIcon
        .closest('.single-nav-img')
        ?.querySelector('.img_producto_container.is-selected a.fslightbox');
      if (activeLink) activeLink.click();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initFlickity();
    initZoomHover();
    initZoomIconTrigger();
  });

  window.ProductVisuals = {
    updateMedia
  };
})();